import * as React from 'react'
import { PersonModel } from '../../model/autogen/PersonModel';
import { Card, CardContent, Typography, Button } from '@material-ui/core';
import twitter_logo from "../../assets/twitter.svg";
import facebook_logo from "../../assets/facebook.svg";
import { NBSP, strIsNullOrEmpty } from '../../utils/string';
import { BlockQuote } from '../material/block-quote';
import { DOCUMENT_TYPE_ICONS } from '../document-icons';
import { AbstractDocumentKind } from '../../model/autogen/AbstractDocumentKind';
import { Link } from "react-router-dom";
import { Iif } from '../iif';
import { UserLevel } from "../../model/autogen/UserLevel";
import { AuthContext } from "../../auth-context";
import { QuoteModel } from '../../model/autogen/QuoteModel';
import { Spacer } from '../../components/utility-components';
// import { DisplayTweet } from 'components/material/display-tweet';
import { TweetModel } from 'model/autogen/TweetModel';
import { PersonType_DISPLAY_NAMES } from '../../model/autogen/PersonType';
export interface IPersonCard {
    model: PersonModel;
    quotedIn: QuoteModel[];
    tweets: TweetModel[];
}

function quoteSortComparator(a: QuoteModel, b: QuoteModel) {
    const aDateStr = `${a.dateOfQuote}`;
    const bDateStr = `${b.dateOfQuote}`;
    const retVal = aDateStr.localeCompare(bDateStr);
    if (retVal > 0) {
        return -1;
    } else if (retVal < 0) {
        return 1;
    }
    return 0;
}

export const PersonCard = (props: IPersonCard) => {
    const personTypeLabels = PersonType_DISPLAY_NAMES;
    const personType = personTypeLabels[props.model.personType];
    const recentQuotes = props.model.quotes.length > 0 ? props.model.quotes.sort(quoteSortComparator).slice(0, 5) : []

    const recentQuotedIn = props.quotedIn.length > 0 ? props.quotedIn.sort(quoteSortComparator).slice(0, 5) : []
    return <Card>
        <CardContent>
            <AuthContext.Consumer>
                {({ methods, state: { user } }) => (<>
                    <Iif show={user.level >= UserLevel.Editor}>
                        <Link style={{ float: 'right' }} to={"/person/" + props.model.id}>{DOCUMENT_TYPE_ICONS[AbstractDocumentKind.Person]}</Link>
                    </Iif>
                </>)}
            </AuthContext.Consumer>

            <Typography variant='title'>Party Affiliation: {props.model.partyAffiliation}</Typography>
            <br />
            <Typography variant='title'>Position: {personType}</Typography>

            <br />

            <Typography variant="h6">Social Media Accounts</Typography><br />

            {/* {!strIsNullOrEmpty(props.model.twitter) && <Button onClick={() => window.location.href = props.model.twitter}> */}
            {props.model.twitterHandles && props.model.twitterHandles.length == 1 &&
                <Button onClick={() => window.location.href = `https://www.twitter.com/${props.model.twitterHandles[0].displayName}`}>
                    <img src={twitter_logo} style={{ color: 'blue', fill: 'currentColor', width: 30, height: 30 }} />{NBSP}{`@${props.model.twitterHandles[0].displayName}`}</Button>}
            <br />

            {!strIsNullOrEmpty(props.model.facebook) && <Button onClick={() => window.location.href = props.model.facebook}>
                <img src={facebook_logo} style={{ color: 'blue', fill: 'currentColor', width: 30, height: 30 }} />{NBSP}{props.model.facebook}</Button>}
            <br /><br />
            <Typography variant="h6">Recently Quoted Saying</Typography>
            {recentQuotes.map((q, i) => {
                return <BlockQuote quote={q} subjects={q.subjects} key={i} />
            })}
            <Spacer />
            <Typography variant="h6">Recently Quoted By</Typography>
            {recentQuotedIn.map((qi, i) => {
                return <BlockQuote quote={qi} author={qi.person} key={i} />
            })}
            {/* <Spacer />
            <Typography variant="h6">Recent Tweets</Typography>
            {props.tweets.map((tw, i) => {
                return <DisplayTweet initiallyExpanded={false} tweet={tw} key={i} />
            })} */}
        </CardContent>
    </Card>
}


// WEBPACK FOOTER //
// ./src/components/person-card/index.tsx